module.exports = __webpack_public_path__ + "static/media/magic-leap.3e56bd28.jpg";